import React from 'react';
import ListItem from 'components/ListItem';
import { SprayEventJustification } from 'services/sprayEvents/types';

export interface OwnProps {
    justification?: SprayEventJustification;
}

type Props = OwnProps;

export default class SummaryApplicationJustification extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | null {
        const { justification } = this.props;

        if (!justification) {
            return null;
        }

        return (
            <ListItem
                description="Justification"
                value={justification}
            />
        );
    }
}
